import { createListenerMiddleware } from '@reduxjs/toolkit'

import { setUser } from '@/stores/slices/userSlice'
import { clearLicenseError } from '@/stores/slices/licenseErrorSlice'
import { clearLicenseInfo } from '@/utils/license'

const authListenerMiddleware = createListenerMiddleware()

authListenerMiddleware.startListening({
  actionCreator: setUser,
  effect: (action, listenerApi) => {
    if (!action.payload.isSignIn) {
      clearLicenseInfo()
      listenerApi.dispatch(clearLicenseError())
    }
  },
})

export default authListenerMiddleware
